import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE, VIEW_STATE} from "../utils/enums";
import utils from "../utils";
import toast from "../utils/toast";

const slice = createSlice({
    name: 'comment',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
        listViewState: VIEW_STATE.LOADING,
        comments: [],
        hasMore: true,
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },
        setListViewState: (state, action) => {
            state.listViewState = action.payload
        },
        setComments: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.comments = action.payload
            state.listViewState = VIEW_STATE.LOADED
        },
        addComments: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.comments = [...state.comments, ...action.payload]
        },
        onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer
const {setViewState, setComments, addComments,setListViewState,setModalViewState,onError} = slice.actions

export const getCourseComments = (courseId,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getCourseComments(courseId,page)
        if (page === 0) dispatch(setComments(data?.data));
        else dispatch(addComments(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}

export const addCourseComment = (courseId,text,onSuccess,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        await api.course.addCourseComment(courseId,text)
        dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
        onSuccess()
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}
